function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-18,-15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3,40C10.367,40 9.583,39.683 8.95,39.05C8.317,38.417 8,37.633 8,36.7C8,35.767 8.317,34.983 8.95,34.35C9.583,33.717 10.367,33.4 11.3,33.4C12.233,33.4 13.017,33.717 13.65,34.35C14.283,34.983 14.6,35.767 14.6,36.7C14.6,37.633 14.283,38.417 13.65,39.05C13.017,39.683 12.233,40 11.3,40ZM24,40C23.067,40 22.283,39.683 21.65,39.05C21.017,38.417 20.7,37.633 20.7,36.7C20.7,35.767 21.017,34.983 21.65,34.35C22.283,33.717 23.067,33.4 24,33.4C24.933,33.4 25.717,33.717 26.35,34.35C26.983,34.983 27.3,35.767 27.3,36.7C27.3,37.633 26.983,38.417 26.35,39.05C25.717,39.683 24.933,40 24,40ZM36.7,40C35.767,40 34.983,39.683 34.35,39.05C33.717,38.417 33.4,37.633 33.4,36.7C33.4,35.767 33.717,34.983 34.35,34.35C34.983,33.717 35.767,33.4 36.7,33.4C37.633,33.4 38.417,33.717 39.05,34.35C39.683,34.983 40,35.767 40,36.7C40,37.633 39.683,38.417 39.05,39.05C38.417,39.683 37.633,40 36.7,40ZM11.3,27.3C10.367,27.3 9.583,26.983 8.95,26.35C8.317,25.717 8,24.933 8,24C8,23.067 8.317,22.283 8.95,21.65C9.583,21.017 10.367,20.7 11.3,20.7C12.233,20.7 13.017,21.017 13.65,21.65C14.283,22.283 14.6,23.067 14.6,24C14.6,24.933 14.283,25.717 13.65,26.35C13.017,26.983 12.233,27.3 11.3,27.3ZM11.3,14.6C10.367,14.6 9.583,14.283 8.95,13.65C8.317,13.017 8,12.233 8,11.3C8,10.367 8.317,9.583 8.95,8.95C9.583,8.317 10.367,8 11.3,8C12.233,8 13.017,8.317 13.65,8.95C14.283,9.583 14.6,10.367 14.6,11.3C14.6,12.233 14.283,13.017 13.65,13.65C13.017,14.283 12.233,14.6 11.3,14.6Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.647687,-0.77054,0.77054,0.647687,20.1599,27.4304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,21.1L6,6.05L21.05,6.05L21.05,21.1L6,21.1ZM9,18.1L18.05,18.1L18.05,9.05L9,9.05L9,18.1Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default_icon.9067cddbd7cc7d9b42a85574ee9045da.svg";
export { ForwardRef as ReactComponent };